import React from "react";
import VersionHistoryDisplay from "./VersionHistoryDisplay";

interface VersionsTabProps {
  promptId: string;
}

const VersionsTab: React.FC<VersionsTabProps> = ({ promptId }) => {
  return (
    <div className="flex-1 p-6">
      <VersionHistoryDisplay promptId={promptId} isVisible={true} />
    </div>
  );
};

export default VersionsTab;
